// extracted by mini-css-extract-plugin
module.exports =  {"list":"pCmMcl4gH0rRoAWxFKTg"};